export default "__VITE_ASSET__CGwUi12F__"